import {
  CreateContextProvider,
  SimpleForm,
  TextInput,
  ReferenceInput,
  useCreateController,
  AutocompleteInput,
  DateInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SelectInput,
  SaveButton,
  Title,
} from "react-admin";
import { useState } from "react";

import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { dateOnlyProps } from "../../util/dateOnly";
import {
  ROLE_TYPE_CHOICES,
  SPHERE_CHOICES,
  omitEmptyDates,
} from "./positionRoleMeta";

export const UserPositionRoleCreate = (props: any) => {
  const [roleType, setRoleType] = useState("");

  const controller: any = useCreateController({
    resource: "user-position-roles/crud",
    // Data digitada e depois apagada iria como null → 01/01/1970
    transform: omitEmptyDates,
  });

  const changeRoleType = (e: any) => {
    setRoleType(e.target.value);
  };
  const isCommission = roleType === "COMISSAO_EXTERNA";

  return (
    <CreateContextProvider value={controller}>
      <Title title="Cargos e Funções" />
      {/* toolbar={false}: Salvar no topo, na linha do breadcrumb */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Cargos e Funções"
          firstPath="/#/user-position-roles/crud"
          secondTitle="Novo"
          actions={<SaveButton label="Salvar" />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Criar Novo" />
          <CardContent>
            <Grid container columnSpacing={2} rowSpacing={0.5}>
              <Grid item xs={12} md={6}>
                {/* O texto de ajuda citava os códigos técnicos do banco
                    (DTE, CARGOS_FUNCOES…) */}
                <SelectInput
                  source="roleType"
                  label="Tipo de Cargo"
                  fullWidth
                  required
                  helperText="Define quais campos aparecem abaixo"
                  choices={ROLE_TYPE_CHOICES}
                  onChange={(e) => {
                    changeRoleType(e);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ReferenceInput
                  source="roleStatusId"
                  reference="user-role-status/crud"
                  perPage={50}
                >
                  <AutocompleteInput
                    label="Status do Cargo"
                    optionText="name"
                    optionValue="id"
                    isRequired
                    fullWidth
                    helperText={false}
                  />
                </ReferenceInput>
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  source="name"
                  label={
                    "Nome " + (isCommission ? "da Comissão" : "do Cargo")
                  }
                  required
                  fullWidth
                  helperText={
                    roleType === "DTE"
                      ? "(Chefe, Subchefe, Secretário...)"
                      : roleType === "CARGOS_FUNCOES"
                      ? "(Presidente, Diretor, Conselheiro(a)...)"
                      : isCommission
                      ? "Comissão XYZ"
                      : false
                  }
                />
              </Grid>
              {isCommission && (
                <>
                  <Grid item xs={12} md={6}>
                    <TextInput
                      source="secondaryRole"
                      label="Cargo (comissões externas)"
                      fullWidth
                      helperText={"Ex.: Titular"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SelectInput
                      source="sphere"
                      label="Esfera de Atuação"
                      fullWidth
                      required
                      helperText={"Ex.: Federal, Estadual, Municipal..."}
                      choices={SPHERE_CHOICES}
                    />
                  </Grid>
                </>
              )}

              {roleType === "DTE" && (
                <Grid item xs={12}>
                  <ReferenceInput
                    source="technicalDivisionId"
                    reference="technical-divisions/crud"
                  >
                    <AutocompleteInput
                      label="Divisão Técnica"
                      optionText="name"
                      optionValue="id"
                      fullWidth
                      helperText={false}
                    />
                  </ReferenceInput>
                </Grid>
              )}
              {!isCommission && (
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="yearRange"
                    label="Período"
                    fullWidth
                    helperText={"Ex.: 2006/2012"}
                  />
                </Grid>
              )}

              <Grid item xs={12} md={isCommission ? 6 : 4}>
                <DateInput
                  source="fromDate"
                  label="A partir de (data)"
                  {...dateOnlyProps}
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={isCommission ? 6 : 4}>
                <DateInput
                  source="toDate"
                  label="Até (data)"
                  {...dateOnlyProps}
                  fullWidth
                  helperText={false}
                />
              </Grid>

              <Grid item xs={12}>
                <ReferenceArrayInput reference="users/crud" source="users">
                  <AutocompleteArrayInput
                    optionText="fullName"
                    optionValue="id"
                    label="Sócios"
                    filterToQuery={(searchText: string) => ({
                      mailName: searchText,
                    })}
                    helperText={
                      "Consulte pelo / nome / mail / cpf. É possível selecionar múltiplos."
                    }
                  />
                  {/* //TODO CREATION NOT WORKING */}
                  {/* //TODO NOT SELECTING EXISTING */}
                </ReferenceArrayInput>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
